import typography from '../typography';
import palette from '../palette';

export default {
  "@global": {
    html: {
      "-webkit-overflow-scrolling": "touch"
    },
    body: {
      fontFamily: typography.fontFamily,
      "-webkit-font-smoothing": "antialiased",
      fontWeight: typography.fontWeightMedium,
      letterSpacing: typography.letterSpacing,
      color: palette.black,
      backgroundColor: palette.white
    },
    ":root": {
      "--ck-z-default": "1500"
    }
  }
};